import i18next from 'i18next';
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from 'react-i18next';
import translation from './en/translation.json';
import translationFr from './fr/translation.json';
import translationDe from './de/translation.json';
import translationEs from './es/translation.json';

const resources = {
  en: {
    translation
  },
  fr: {
    translation: translationFr
  },
  de: {
    translation: translationDe
  },
  es: {
    translation: translationEs
  }
};

i18next
  .use(detector)
  .use(initReactI18next)
    .init({
      supportedLngs: ['en', 'fr', 'de', 'es'], // List of supported languages
      detection: {
        order: ['localStorage', 'navigator'],
        lookupLocalStorage: 'tt-lang',
        cacheUserLanguage: 'tt-lang',
      },
      debug: import.meta.env.DEV,
      resources,
      fallbackLng: "en", // use en if detected lng is not available
      interpolation: {
        escapeValue: true,
      }
    });
